import React from 'react';
import './PastPicksCard.css'
import teamIcons from './../../utils/teamIcons';

function PastPicksCard({
    stats,
    picks
}) {

    
    return (
        <>
            <div className='past-picks-section'>
                <div className='past-picks-top-row'>
                    <span className='section-heading past-picks-title'>Pick History</span>
                    <div className='past-picks-stats'>
                        <span className='past-picks-stat'>
                            <span className='past-picks-stat-value'>{stats['start_streak']}</span>
                            <span className='past-picks-stat-label'>Start Streak</span>
                        </span>
                        <span className='past-picks-stat-divider' />
                        <span className='past-picks-stat'>
                            <span className='past-picks-stat-value'>{stats['total_correct']}</span>
                            <span className='past-picks-stat-label'>Total Correct</span>
                        </span>
                    </div>
                </div>
                <div className='past-picks-weeks-row'>
                {

                    picks.map((team, i) => {
                        let currTeam =  Object.keys(team)[0];
                        let result = Object.values(team)[0];

                        if(currTeam === 'Commanders') {
                            var mySVG = document.getElementById('Commanders');
                            if(mySVG) mySVG.setAttribute("viewBox", "-100 -150 675 400")
                        }
                        if(currTeam.includes('Team')) {
                            return (
                                    <div key={i} className='past-picks-chip'>
                                        <span className='past-picks-week'>W{i+1}</span>
                                        <span className='past-picks-none'>&ndash;</span>
                                    </div>
                                );
                        } else if(result === '') {
                            return (
                                    <div key={i} className='past-picks-chip'>
                                        <span className='past-picks-week'>W{i+1}</span>
                                        {React.createElement(teamIcons[currTeam], {})}
                                    </div>
                            );
                        } else if(result) {
                            return (
                                    <div key={i} className='past-picks-chip correct-pick'>
                                        <span className='past-picks-week'>W{i+1}</span>
                                        {React.createElement(teamIcons[currTeam], {})}
                                    </div>
                            );
                        } else {
                            return (
                                    <div key={i} className='past-picks-chip incorrect-pick'>
                                        <span className='past-picks-week'>W{i+1}</span>
                                        {React.createElement(teamIcons[currTeam], {})}
                                    </div>
                            );
                        }
                    })
                }
                </div>
            </div>
        </>
    );

}

export default PastPicksCard;